import React, { Component } from 'react';
import { Container, Row, Col,  ButtonDropdown, DropdownToggle, DropdownItem, DropdownMenu } from 'reactstrap';
import { withRouter } from 'react-router';
import { Typeahead } from 'react-bootstrap-typeahead';
import _ from 'lodash';
import qs from 'qs';

import { getAssetsMatching, getAllCategories, getVendors } from '../../Api';
import { filterArrayWithoutAttribute } from '../../utils/array'
import { PAGINATION_VALUE_50, PAGINATION_VALUE_25, PAGINATION_VALUE_100, PAGINATION_VALUE_200 } from '../../Constants';
import List from '../../components/common/List/List';
import AssetListItem from '../../components/AssetListItem/AssetListItem';
import Spinner from '../../components/common/Spinner/Spinner';
import Pagination from '../../components/common/Pagination/Pagination'
import BetaBanner from '../../images/BetaBanner.jpg';

class Browse extends Component {

  /**
   * @param {object} props - props passed down to the container component
   *
   * ** state **
   * isLoading - used to display a loading icon when waiting for api response
   * results - assets returned from the api response
   * totalResults - count of results returned returned from api
   * searchTerm - defaulted to match_all to get everything and set to whatever was inputed in search bar
   * filter - Combindation of all filters i.e {CATEGORY: 'Servers'}, {VENDOR: 'Dell'}...
   * sort - based on dropdown on screen - defaulted to RELEVANCE
   * from - pagination value where to start taking results
   * size - pagination value how many results to take
   * totalPageSize - how many pages there is based on totalResults / size
   * pageNumber - which page the user on, defaulted to 0
   * toggleSort - used to display and hide the sort dropdown
   * categories - categories from api used to drive the category dropdown
   * vendors - vendors from api used to drive the vendor dropdown
   * existingCategoryFilterViaURL - used to hold url filters params for categories
   * existingVendorFilterViaURL - used to hold url filters params for vendors
   * urlState - params pulled off url
   * prevDisabled - boolean controlling if the pagination prev is disabled
   * nextDisabled - boolean controlled if the pagination next is disabled
   */
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      results: [],
      // Set initial total results to something ? pageinationsize
      totalResults: 1000,
      searchTerm: 'match_all',
      filter: [],
      // Pagination
      sort: 'RELEVANCE',
      from: 0,
      size: PAGINATION_VALUE_25,
      totalPageSize: 0,
      pageNumber: 1,
      // Sort
      toggleSort: false,
      // Filters
      categories: [],
      vendors: [],
      existingCategoryFilterViaURL: [],
      existingVendorFilterViaURL: [],
      urlState: null,
      prevDisabled: true,
      nextDisabled: false,
    };
  }

  componentWillMount() {
    this.checkForUrlParamsInLocationSearch(this.props.location.search)

    getAllCategories().then((response) => {
      let orderedCategories = _.orderBy(response.data.results, ['category'],['asc']);
      this.setState({ categories: orderedCategories });
    });
  }

  componentWillReceiveProps(nextProps) {
    // slice from first '?'
    const urlState = nextProps.location.search.slice(1);

    // if the url state is different to state then check for updates in the url and reload
    if (urlState !== this.state.urlState) {
      this.checkForUrlParamsInLocationSearch(nextProps.location.search);
    }
  }

   setPaginationControlsState = (pageNumber) => {
        this.setState({
            prevDisabled: pageNumber <= 1,
            nextDisabled: !(pageNumber < this.state.totalPageSize)
        })
    }

  // Checks react route location.search for url params and refreshes data.
  checkForUrlParamsInLocationSearch = (location) => {
    const params = qs.parse(location, { ignoreQueryPrefix: true });

    const term = params.searchTerm ? params.searchTerm : 'match_all';
    const sort = params.sort ? params.sort : 'RELEVANCE';

    let vendorFilter = [];
    let categoriesFilter = [];

    if (params.filterVendor) {
      if (params.filterVendor.constructor === Array) {
        let x = params.filterVendor.map((filterString) => {return {vendor: filterString} })
        vendorFilter.push(...x);
       } else {
        vendorFilter.push({vendor: params.filterVendor});
       }
    }

    if (params.filterCategory) {
      if (params.filterCategory.constructor === Array) {
        const x = params.filterCategory.map((filterString) => {return {category: filterString} });
        categoriesFilter.push(...x);
       } else {
        categoriesFilter.push({category: params.filterCategory});
       }
    }

    const filter = categoriesFilter.concat(vendorFilter)
    const from = params.from ? parseInt(params.from, 10) : 0;
    const size = params.size ? parseInt(params.size, 10) : PAGINATION_VALUE_25;

    this.setState({
      existingCategoryFilterViaURL: categoriesFilter,
      existingVendorFilterViaURL: vendorFilter
    }, () => {
      this.reload(term, filter, sort, from, size);
    })
  }


  /**
   * @param  {int} size
   * limitChangeAction fired when the user has selected a new value for size
   * sets state and calls reload.
   */
  limitChangeAction = (size) => {
    this.setState({size, from: 0, isLoading: true, pageNumber: 1}, () => {
    this.setPaginationControlsState(1);
      this.reload(this.state.searchTerm, this.state.filter, this.state.sort, 0, size);
    });
  }

  /**
   * nextAction called when the user presses the next control in the pagination component
   * sets state and calls reload
   */
  nextAction = () => {
    const from = this.state.from + this.state.size;
    const pageNumber = this.state.pageNumber + 1;
    const isLoading = true;

    this.setState({from, isLoading, pageNumber }, () => {
      this.setPaginationControlsState(pageNumber);
      this.reload(this.state.searchTerm, this.state.filter, this.state.sort, from, this.state.size);
    });
  }

   /**
   * prevAction called when the user presses the next control in the pagination component
   * sets state and calls reload
   */
  previousAction = () => {
    const from = (this.state.from) - this.state.size;
    const pageNumber = this.state.pageNumber - 1;
    const isLoading = true;

    this.setState({from, isLoading, pageNumber}, () => {
      this.setPaginationControlsState(pageNumber);
      this.reload(this.state.searchTerm, this.state.filter, this.state.sort, from, this.state.size);
    });
  }


  /**
   * @param  {object} e - the event fired byt the pageNumber input
   * If the user has pressed the enter button after validation then
   * state is set and the reload function is called.
   *
   */
  pageNumberChangeAction = (e) => {
    if (e.keyCode === 13) {
        if (e.target.value < 1 || e.target.value > this.state.totalPageSize || e.target.value === 'e') {
            let from = this.state.size * 1;
            this.setState({pageNumber: 1, isLoading: true, from}, () => {
              this.reload(this.state.searchTerm, this.state.filter, this.state.sort, from, this.state.size);
            });
        } else {
            let from = (this.state.size * e.target.value) - this.state.size;
            let pageNumber = parseInt(e.target.value, 10);
            this.setState({from, isLoading: true, pageNumber}, () => {
            this.reload(this.state.searchTerm, this.state.filter, this.state.sort, from, this.state.size);
            this.setPaginationControlsState(pageNumber);
            });
        }
    }
  }

  calculatePages = (total, size) => {
    return Math.ceil(total / size);
  }

  /**
   * @param  {string} searchTerm
   * @param  {array} filter
   * @param  {string} sort
   * @param  {int} from
   * @param  {int} size
   *
   * calls getAssetsMatching in api.js that returns assets based on the parameters passed in
   * and sets the new results on state.
   */
  reload = (searchTerm, filter, sort, from, size) => {
    let overflowSize = 0;
    // Ensure we dont overflow paginatio, i.e user is on last page
    if ((from + size) > this.state.totalResults) {
      overflowSize = ((from + size) - this.state.totalResults);
    }

    getAssetsMatching(
      searchTerm,
      filter,
      sort,
      from,
      overflowSize > 0 ? overflowSize : size)
    .then((response) => {
        this.setState({
          searchTerm,
          filter,
          sort,
          from,
          size,
          totalResults: response.data.total_results,
          results: response.data.results,
          isLoading: false,
          showPaginatedControl: (response.data.results.length > 0 ? true : false),
          totalPageSize: this.calculatePages(response.data.total_results, size),
        }, () => {
          this.updateURLToReflectState();
        })
      }).catch(() => {
        this.setState({isLoading: false, results: []});
      })
  }

   /**
   * @param  {object} e
   * fired when user selects a sort from the dropdown
   */
  updateSort = (e) => {
    let sortBy = e.target.innerText.toLowerCase();
    this.reload(this.state.searchTerm, this.state.filter, sortBy, this.state.from, this.state.size);
  }

  toggleSortDropdown = () => {
    this.setState({toggleSort: !this.state.toggleSort});
  }
  /**
   * @param  {array} filters
   * vendorFilterChanged fired when the vendor dropdown is updated
   */
  vendorFilterChanged = (filters) => {
    this.setState({existingVendorFilterViaURL: filters});
    // Extract out just filters without VENDOR
    let existingCategoriesFilters = filterArrayWithoutAttribute(this.state.filter, 'vendor');

    // Add new filters and combine the reduced filters
    let combinedFilters = existingCategoriesFilters.concat(filters);

    // Update the result set by calling reload, this will also set state with the new filter object on completion.
    // Ensure we clear the cache for when the user clicks dropdown again
    this.setState({vendors: [], pageNumber: 1}, () => {
      this.reload(
        this.state.searchTerm,
        combinedFilters,
        this.state.sort,
        0,
        this.state.size
      )
    })
  }

   /**
   * @param  {array} filters
   * categoryFilterChanged fired when the category dropdown is updated
   */
  categoryFilterChanged = (filters) => {
    this.setState({existingCategoryFilterViaURL: filters});
    // Extract out just filters without CATEGORY
    let existingVendorFilters = filterArrayWithoutAttribute(this.state.filter, 'category');

    let combinedFilters = existingVendorFilters.concat(filters);

    this.setState({pageNumber: 1}, () => {
      this.reload(
        this.state.searchTerm,
        combinedFilters,
        this.state.sort,
        0,
        this.state.size
      )
    });
  }
  /**
   * @param  {string} term
   * fired when user types in the typeahead
   */
  getVendorsForDropdown = (term) => {
    if (term.length > 0) {
      let categoryFilter = this.state.categoryFilter;
      return getVendors(term, categoryFilter).then(response => {
        this.setState({vendors: response.data.results});
      });
    }
  }

  // Pulls vars of state and ensure that the url is correct, state must be correct at before this is calledd
  updateURLToReflectState = () => {
    let params = {};

    params.searchTerm = this.state.searchTerm;
    params.size = this.state.size;
    params.from = this.state.from;
    params.sort = this.state.sort;
    params.filterVendor = this.state.filter.filter((f) => { return f['vendor']; }).map((f) => { return f['vendor']; });
    params.filterCategory = this.state.filter.filter((f) => { return f['category']; }).map((f) => { return f['category']; });

    // Stringy params and update state
    const searchParamsCombined = qs.stringify(params, { encode: false, arrayFormat: 'repeat' });
    this.setState({urlState: searchParamsCombined}, () => {
      this.props.history.push(`/browse?${searchParamsCombined}`);
    });
  }

  render() {
    if (this.state.isLoading) {
      return (
        <Container>
          <Spinner />
        </Container>
      );
    }

    const paginatedControl = this.state.showPaginatedControl ?
      (<div className="sub-footer p-5 pt-10">
          <Pagination showPageControl={true} pageNumber={this.state.pageNumber} pageCount={this.state.totalPageSize} previousDisabled={this.state.prevDisabled} nextDisabled={this.state.nextDisabled} pageNumberChangeAction={this.pageNumberChangeAction} limitChangeAction={this.limitChangeAction} nextAction={this.nextAction} previousAction={this.previousAction} values={[PAGINATION_VALUE_25, PAGINATION_VALUE_50, PAGINATION_VALUE_100, PAGINATION_VALUE_200]} limit={this.state.size} />
        </div>)
      : null;

    const searchHeader = this.state.searchTerm !== 'match_all' && this.state.searchTerm !== null ?
        (<h2 className="pt-2">Search results for <strong><em>{this.state.searchTerm}</em></strong></h2>)
        : null;

    const dropdownStyle = this.state.toggleSort ? "btn-sort-dropdown-open" : "btn-sort-dropdown";

    const sortByComponent = this.state.results.length > 0 ?
      (<ButtonDropdown id="browse-sort" className="pt-3 sort" isOpen={this.state.toggleSort} toggle={this.toggleSortDropdown}>
        <DropdownToggle className={dropdownStyle} size="lg">
          <span className="text-light"> SORT BY </span>
          <span className="text-dark">{this.state.sort}</span>
        </DropdownToggle>
      <DropdownMenu>
        <DropdownItem id="browse-sort-item1" title="Sort by relevance" onClick={this.updateSort}>RELEVANCE</DropdownItem>
        <DropdownItem id="browse-sort-item2" title="Sort by category" onClick={this.updateSort}>CATEGORY</DropdownItem>
        <DropdownItem id="browse-sort-item3" title="Sort by vendor" onClick={this.updateSort}>VENDOR</DropdownItem>
      </DropdownMenu>
      </ButtonDropdown>
      ) : null;

    return (
      <div className="min-height-div">
        <div className="jumbotron">
          <Container>
            <Row>
              <Col>
                <label htmlFor="vendor" className="filter-heading text-uppercase">Vendor</label>
                <Typeahead
                  id="browse-vendor"
                  inputProps={{id:"vendor", name:"vendor"}}
                  aria-label="Filter by vendor"
                  selected={this.state.existingVendorFilterViaURL}
                  placeholder="Filter by vendor..."
                  multiple
                  labelKey="vendor"
                  options={this.state.vendors}
                  onInputChange={this.getVendorsForDropdown}
                  onChange={this.vendorFilterChanged} />
              </Col>
              <Col>
                <label htmlFor="category" className="filter-heading text-uppercase">Category</label>
                <Typeahead
                  id="browse-category"
                  inputProps={{id:"category", name:"category"}}
                  aria-label="Filter by category"
                  selected={this.state.existingCategoryFilterViaURL}
                  placeholder="Filter by category..."
                  multiple
                  labelKey="category"
                  options={this.state.categories}
                  onChange={this.categoryFilterChanged} />
              </Col>
            </Row>
          </Container>
        </div>
        <Container role="main">
          {searchHeader}
          {sortByComponent}
          <Row>
            <Col md="8" sm="12">
                <div className="min-height-div">
                    <List
                    customId="browse-list"
                    items={this.state.results}
                    component={AssetListItem}
                    customClass="asset-list pl-0"
                    />
                </div>
            </Col>
            <Col md="4" className="py-4 mt-2">
                <img id="browse-image" alt="Flexera Technopedia Beta Advert" width="350" src={BetaBanner}/>
            </Col>
          </Row>
        </Container>
        {paginatedControl}
        </div>
    );
  }
}



export default withRouter(Browse);



// WEBPACK FOOTER //
// ./src/containers/Browse/Browse.js